<template>
  <div class="d-flex w-100 h-100">
    <div v-if="!exportInvoice" class="d-flex flex-column w-100 h-100">
      <header class="d-flex flex-column site-header mt-5" id="header">
        <img src="img/iRender-Logo-006.svg" style="height: 50px" />

        <h1 class="site-header__title" data-lead-id="site-header-title">
          THANK YOU!
        </h1>
      </header>

      <div
        class="d-flex flex-column main-content"
        style="margin-top: 20px; text-align: center"
      >
        <div style="margin-bottom: 0">
          <svg
            width="60px"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 496.158 496.158"
            style="enable-background: new 0 0 496.158 496.158"
            xml:space="preserve"
          >
            <path
              style="fill: #42a5f5"
              d="M496.158,248.085c0-137.021-111.07-248.082-248.076-248.082C111.07,0.003,0,111.063,0,248.085
						c0,137.002,111.07,248.07,248.082,248.07C385.088,496.155,496.158,385.087,496.158,248.085z"
            />
            <path
              style="fill: #ffffff"
              d="M384.673,164.968c-5.84-15.059-17.74-12.682-30.635-10.127c-7.701,1.605-41.953,11.631-96.148,68.777
						c-22.49,23.717-37.326,42.625-47.094,57.045c-5.967-7.326-12.803-15.164-19.982-22.346c-22.078-22.072-46.699-37.23-47.734-37.867
						c-10.332-6.316-23.82-3.066-30.154,7.258c-6.326,10.324-3.086,23.834,7.23,30.174c0.211,0.133,21.354,13.205,39.619,31.475
						c18.627,18.629,35.504,43.822,35.67,44.066c4.109,6.178,11.008,9.783,18.266,9.783c1.246,0,2.504-0.105,3.756-0.322
						c8.566-1.488,15.447-7.893,17.545-16.332c0.053-0.203,8.756-24.256,54.73-72.727c37.029-39.053,61.723-51.465,70.279-54.908
						c0.082-0.014,0.141-0.02,0.252-0.043c-0.041,0.01,0.277-0.137,0.793-0.369c1.469-0.551,2.256-0.762,2.301-0.773
						c-0.422,0.105-0.641,0.131-0.641,0.131l-0.014-0.076c3.959-1.727,11.371-4.916,11.533-4.984
						C385.405,188.218,389.034,176.214,384.673,164.968z"
            />
          </svg>
        </div>
        <p class="main-content__body" data-lead-id="main-content-body">
          Thank you for recharging your account balance. Your transaction is
          being processed. This process may take 2-5 minutes. Please feel free
          to contact us if you need any further information!
        </p>
        <!-- <p>
				<a href="javascript:void(0)" id="gohome" class="go-home">Do recharge again</a>
      </p>-->

        <div v-if="region === 'VN'" class="mt-5 mb-3">
          <div>
            <el-button @click="exportInvoice = true" type="primary" round
              >Export invoice VAT</el-button
            >
            <el-button @click="noReceipts" round>No receipts</el-button>
          </div>
          <div class="mt-3" style="font-size: 0.85rem">
            <span>*** Instructions for export VAT invoices</span>
            <el-link
              :href="$exportInvoiceDocsLink"
              class="ml-2"
              :underline="false"
              type="primary"
              target="_blank"
              >Read more</el-link
            >
          </div>
        </div>
      </div>

      <footer class="site-footer mt-3" id="footer">
        <p class="site-footer__fineprint" id="fineprint">
          Copyright ©2019 - 2022
          <strong style="color: #42a5f5">iRender</strong> | All Rights Reserved
        </p>
      </footer>
    </div>
    <div
      v-else
      class="d-flex flex-fill justify-content-center align-items-center"
    >
      <el-card
        :body-style="{ padding: '3rem' }"
        style="margin: 1rem"
        shadow="never"
      >
        <div class="d-flex flex-column profile-container">
          <div class="d-flex flex-column justify-content-center">
            <img
              class="no-select"
              src="/logo/Gpuhub-logo-text.svg"
              alt="iRender"
              height="30"
            />
            <div class="d-flex justify-content-center mt-1">
              Export invoice VAT
            </div>
          </div>
          <el-form
            class="mt-5"
            style="width: 35rem"
            :model="request"
            :rules="rules"
            ref="exportInvoice"
            autocomplete="off"
          >
            <div class="d-flex flex-column">
              <div class="profile-item">
                <div class="profile-title">
                  <span>Customer type</span>
                </div>
                <div class="profile-content">
                  <el-radio-group
                    :disabled="hadSend"
                    v-model="request.customerType"
                    @input="change"
                    style="margin-top: 0.9rem"
                  >
                    <el-radio :label="customerTypeList.personal"
                      >Personal</el-radio
                    >
                    <el-radio :label="customerTypeList.business"
                      >Business</el-radio
                    >
                  </el-radio-group>
                </div>
              </div>
              <div>
                <div class="profile-item">
                  <div class="profile-title">
                    <span>Invoice receipt email</span>
                  </div>
                  <div class="profile-content">
                    <el-form-item prop="email">
                      <el-input
                        :disabled="hadSend"
                        v-model="request.email"
                        @input="change"
                        size="small"
                        placeholder="Email..."
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="profile-item">
                  <div class="profile-title">
                    <span>{{
                      request.customerType === customerTypeList.personal
                        ? "Full name"
                        : "Company name"
                    }}</span>
                  </div>
                  <div class="profile-content">
                    <el-form-item prop="name">
                      <el-input
                        :disabled="hadSend"
                        v-model="request.name"
                        @input="change"
                        size="small"
                        :placeholder="`${
                          request.customerType === customerTypeList.personal
                            ? 'Your name...'
                            : 'Company name...'
                        }`"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="profile-item">
                  <div class="profile-title">
                    <span>{{
                      request.customerType === customerTypeList.personal
                        ? "Address"
                        : "Company address"
                    }}</span>
                  </div>
                  <div class="profile-content">
                    <el-form-item prop="address">
                      <el-input
                        :disabled="hadSend"
                        v-model="request.address"
                        @input="change"
                        size="small"
                        :placeholder="`${
                          request.customerType === customerTypeList.personal
                            ? 'Address...'
                            : 'Company address...'
                        }`"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div
                  class="profile-item"
                  v-if="request.customerType === customerTypeList.business"
                >
                  <div class="profile-title">
                    <span>Tax code</span>
                  </div>
                  <div class="profile-content">
                    <el-form-item prop="tax">
                      <el-input
                        :disabled="hadSend"
                        v-model="request.tax"
                        @input="change"
                        size="small"
                        placeholder="Tax code..."
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="profile-item">
                  <div class="profile-title">
                    <span>Note</span>
                  </div>
                  <div class="profile-content">
                    <el-form-item prop="note">
                      <el-input
                        :disabled="hadSend"
                        type="textarea"
                        placeholder="Note ..."
                        v-model="request.note"
                        maxlength="500"
                        :rows="2"
                        show-word-limit
                      >
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div v-if="!hadSend" class="profile-item mt-4">
                <div class="profile-title"></div>
                <div class="profile-content">
                  <el-button
                    @click="sendRequest('exportInvoice')"
                    size="small"
                    type="primary"
                    >Send request</el-button
                  >
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div v-if="hadSend" style="width: 35rem" class="mt-5 ml-5">
          <div style="color: #ff9800; font-size: 0.95rem">
            <div>
              • Your invoice information has been received by us. We will
              process your request within 24 hours from the time of successful
              request submission.
            </div>
            <div class="mt-2">
              • If you have any questions please contact us ketoan@irendering.net
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<style scoped>
/*
#   $$$$$$\  $$\           $$\                 $$\
#  $$  __$$\ $$ |          $$ |                $$ |
#  $$ /  \__|$$ | $$$$$$\  $$$$$$$\   $$$$$$\  $$ | $$$$$$$\
#  $$ |$$$$\ $$ |$$  __$$\ $$  __$$\  \____$$\ $$ |$$  _____|
#  $$ |\_$$ |$$ |$$ /  $$ |$$ |  $$ | $$$$$$$ |$$ |\$$$$$$\
#  $$ |  $$ |$$ |$$ |  $$ |$$ |  $$ |$$  __$$ |$$ | \____$$\
#  \$$$$$$  |$$ |\$$$$$$  |$$$$$$$  |\$$$$$$$ |$$ |$$$$$$$  |
#   \______/ \__| \______/ \_______/  \_______|\__|\_______/
*/
@font-face {
  font-family: "Akkurat-Regular";
  /* src: url("../font/akkurat/lineto-akkurat-regular.eot");
  src: url("../font/akkurat/lineto-akkurat-regular.eot?#iefix")
      format("embedded-opentype"),
    url("../font/akkurat/lineto-akkurat-regular.woff") format("woff"); */
  font-weight: normal;
  font-style: normal;
}

.cf:before,
.cf:after {
  content: " ";
  display: table;
}
.cf:after {
  clear: both;
}

* {
  box-sizing: border-box;
}

html {
  font-size: 16px;
  background-color: #fffffe;
}
body {
  padding: 0 20px;
  min-width: 300px;
  font-family: "Akkurat-Regular", sans-serif;
  background-color: #fffffe;
  color: #1a1a1a;
  text-align: center;
  word-wrap: break-word;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
a:link,
a:visited {
  color: #00c2a8;
}
a:hover,
a:active {
  color: #03a994;
}

/*
#   $$$$$$\  $$\   $$\                     $$\   $$\                           $$\
#  $$  __$$\ \__|  $$ |                    $$ |  $$ |                          $$ |
#  $$ /  \__|$$\ $$$$$$\    $$$$$$\        $$ |  $$ | $$$$$$\   $$$$$$\   $$$$$$$ | $$$$$$\   $$$$$$\
#  \$$$$$$\  $$ |\_$$  _|  $$  __$$\       $$$$$$$$ |$$  __$$\  \____$$\ $$  __$$ |$$  __$$\ $$  __$$\
#   \____$$\ $$ |  $$ |    $$$$$$$$ |      $$  __$$ |$$$$$$$$ | $$$$$$$ |$$ /  $$ |$$$$$$$$ |$$ |  \__|
#  $$\   $$ |$$ |  $$ |$$\ $$   ____|      $$ |  $$ |$$   ____|$$  __$$ |$$ |  $$ |$$   ____|$$ |
#  \$$$$$$  |$$ |  \$$$$  |\$$$$$$$\       $$ |  $$ |\$$$$$$$\ \$$$$$$$ |\$$$$$$$ |\$$$$$$$\ $$ |
#   \______/ \__|   \____/  \_______|      \__|  \__| \_______| \_______| \_______| \_______|\__|
*/
.site-header {
  margin: 0 auto;
  padding: 0px 0 0;
  max-width: 820px;
}
.site-header__title {
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.1;
  text-transform: uppercase;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

/*
#  $$\      $$\           $$\                  $$$$$$\                       $$\                          $$\
#  $$$\    $$$ |          \__|                $$  __$$\                      $$ |                         $$ |
#  $$$$\  $$$$ | $$$$$$\  $$\ $$$$$$$\        $$ /  \__| $$$$$$\  $$$$$$$\ $$$$$$\    $$$$$$\  $$$$$$$\ $$$$$$\
#  $$\$$\$$ $$ | \____$$\ $$ |$$  __$$\       $$ |      $$  __$$\ $$  __$$\\_$$  _|  $$  __$$\ $$  __$$\\_$$  _|
#  $$ \$$$  $$ | $$$$$$$ |$$ |$$ |  $$ |      $$ |      $$ /  $$ |$$ |  $$ | $$ |    $$$$$$$$ |$$ |  $$ | $$ |
#  $$ |\$  /$$ |$$  __$$ |$$ |$$ |  $$ |      $$ |  $$\ $$ |  $$ |$$ |  $$ | $$ |$$\ $$   ____|$$ |  $$ | $$ |$$\
#  $$ | \_/ $$ |\$$$$$$$ |$$ |$$ |  $$ |      \$$$$$$  |\$$$$$$  |$$ |  $$ | \$$$$  |\$$$$$$$\ $$ |  $$ | \$$$$  |
#  \__|     \__| \_______|\__|\__|  \__|       \______/  \______/ \__|  \__|  \____/  \_______|\__|  \__|  \____/
*/
.main-content {
  margin: 0 auto;
  max-width: 820px;
}
.main-content__checkmark {
  font-size: 4.0625rem;
  line-height: 1;
  color: #24b663;
}
.main-content__body {
  margin: 20px 0 0;
  font-size: 1rem;
  line-height: 1.4;
}

/*
#   $$$$$$\  $$\   $$\                     $$$$$$$$\                   $$\
#  $$  __$$\ \__|  $$ |                    $$  _____|                  $$ |
#  $$ /  \__|$$\ $$$$$$\    $$$$$$\        $$ |    $$$$$$\   $$$$$$\ $$$$$$\    $$$$$$\   $$$$$$\
#  \$$$$$$\  $$ |\_$$  _|  $$  __$$\       $$$$$\ $$  __$$\ $$  __$$\\_$$  _|  $$  __$$\ $$  __$$\
#   \____$$\ $$ |  $$ |    $$$$$$$$ |      $$  __|$$ /  $$ |$$ /  $$ | $$ |    $$$$$$$$ |$$ |  \__|
#  $$\   $$ |$$ |  $$ |$$\ $$   ____|      $$ |   $$ |  $$ |$$ |  $$ | $$ |$$\ $$   ____|$$ |
#  \$$$$$$  |$$ |  \$$$$  |\$$$$$$$\       $$ |   \$$$$$$  |\$$$$$$  | \$$$$  |\$$$$$$$\ $$ |
#   \______/ \__|   \____/  \_______|      \__|    \______/  \______/   \____/  \_______|\__|
*/
.site-footer {
  margin: 0 auto;
  padding: 80px 0 25px;
  padding: 0;
  max-width: 820px;
}
.site-footer__fineprint {
  font-size: 0.9375rem;
  line-height: 1.3;
  font-weight: 300;
}

/*
#  $$\      $$\                 $$\ $$\                  $$$$$$\                                $$\
#  $$$\    $$$ |                $$ |\__|                $$  __$$\                               \__|
#  $$$$\  $$$$ | $$$$$$\   $$$$$$$ |$$\  $$$$$$\        $$ /  $$ |$$\   $$\  $$$$$$\   $$$$$$\  $$\  $$$$$$\   $$$$$$$\
#  $$\$$\$$ $$ |$$  __$$\ $$  __$$ |$$ | \____$$\       $$ |  $$ |$$ |  $$ |$$  __$$\ $$  __$$\ $$ |$$  __$$\ $$  _____|
#  $$ \$$$  $$ |$$$$$$$$ |$$ /  $$ |$$ | $$$$$$$ |      $$ |  $$ |$$ |  $$ |$$$$$$$$ |$$ |  \__|$$ |$$$$$$$$ |\$$$$$$\
#  $$ |\$  /$$ |$$   ____|$$ |  $$ |$$ |$$  __$$ |      $$ $$\$$ |$$ |  $$ |$$   ____|$$ |      $$ |$$   ____| \____$$\
#  $$ | \_/ $$ |\$$$$$$$\ \$$$$$$$ |$$ |\$$$$$$$ |      \$$$$$$ / \$$$$$$  |\$$$$$$$\ $$ |      $$ |\$$$$$$$\ $$$$$$$  |
#  \__|     \__| \_______| \_______|\__| \_______|       \___$$$\  \______/  \_______|\__|      \__| \_______|\_______/
#                                                            \___|
*/
@media only screen and (min-width: 40em) {
  .site-header {
    padding-top: 0;
  }
  .site-header__title {
    font-size: 2.5rem;
  }
  .main-content__checkmark {
    font-size: 9.75rem;
  }
  .main-content__body {
    font-size: 1.25rem;
  }
  .site-footer {
    padding: 0px 0 25px;
  }
  .site-footer__fineprint {
    font-size: 1.125rem;
  }
}

.go-home {
  box-shadow: inset 0px 1px 0px -50px #97c4fe;
  background: linear-gradient(to bottom, #3d94f6 5%, #42a5f5 100%);
  background-color: #3d94f6;
  border-radius: 26px;
  border: 1px solid #42a5f5;
  display: inline-block;
  cursor: pointer;
  color: #ffffff !important;
  font-family: Arial;
  font-size: 15px;
  font-weight: bold;
  padding: 12px 42px;
  text-decoration: none;
  text-shadow: 0px 1px 0px #42a5f5;
}
.go-home:hover {
  background: linear-gradient(to bottom, #42a5f5 5%, #3d94f6 100%);
  background-color: #42a5f5;
}
.go-home:active {
  position: relative;
  top: 1px;
}
</style> 

<script>
// CSS
import "@/assets/css/invoice.scss";

//Lib
import { mapState } from "vuex";

// Api
import api from "@/api/baseApi";

// Constant
import {
  SETTINGS_USER_API,
  SETTINGS_TRANSACTION_API,
} from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { regex } from "@/constant/config";

// Extend
import base from "@/scripts/base";

export default {
  extends: base,

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  data() {
    return {
      rules: {
        email: [
          {
            required: true,
            message: this.$lang.register.validationRequiredEmail,
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$lang.register.validationTypeEmail,
            trigger: ["blur", "change"],
          },
          {
            max: 50,
            message: this.$lang.register.validationMaxEmail,
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: this.$lang.profile.validationRequiredFullName,
            trigger: "blur",
          },
          {
            max: 255,
            message: this.$lang.profile.validationMaxFullName,
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "Don't leave your address blank!",
            trigger: "blur",
          },
          {
            max: 500,
            message: this.$lang.profile.validationMaxAddress,
            trigger: ["blur", "change"],
          },
        ],
        tax: [
          {
            required: true,
            message: "Don't leave your Tax code blank!",
            trigger: "blur",
          },
          {
            max: 50,
            message: this.$lang.profile.validationMaxAddress,
            trigger: ["blur", "change"],
          },
        ],
      },

      customerTypeList: {
        personal: 1,
        business: 2,
      },

      transactionCode: null,
      region: null,

      request: {},

      exportInvoice: false,
      hadSend: false,
    };
  },

  created() {
    this.transactionCode = this.$route.query.transactionCode;
    this.region = this.$route.query.region;
    this.getData();
  },

  methods: {
    //#region Invoice and Billing change information
    change() {},
    //#endregion

    //#region Invoice billing ___ View
    getData() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api
        .baseRequest(SETTINGS_USER_API.INVOICE_BILLING_SETTINGS_VIEW, null)
        .then((res) => {
          let responseData = res.data;
          this.request = {
            customerType: responseData.customerType,
            name:
              responseData.customerType === this.customerTypeList.personal
                ? responseData.personalName
                : responseData.businessName,
            address:
              responseData.customerType === this.customerTypeList.personal
                ? responseData.personalAddress
                : responseData.businessAddress,
            email: this.user.email,
            tax:
              responseData.customerType === this.customerTypeList.personal
                ? responseData.personalTaxCode
                : responseData.businessTaxCode,
            note: null,
          };
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
        })
        .catch((error) => {
          this.processCatchApiRequest(error, "Request failed ...");
        });
    },
    //#endregion

    //#region Export invoice
    sendRequest(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.feedStatusLoading(API_CALL_STATUS.LOADING);
          setTimeout(() => {
            let data = {
              customerType: this.request.customerType,
              transactionCode: this.transactionCode,
              name: this.request.name,
              address: this.request.address,
              email: this.request.email,
              tax: this.request.tax,
              note: this.request.note,

              deviceInformation: JSON.stringify(this.getInformationClient()),
            };
            api
              .baseRequest(
                SETTINGS_TRANSACTION_API.TRANSACTION_EXPORT_INVOICE,
                data
              )
              .then(() => {
                this.notificationSuccess(
                  "Success ... !",
                  `Your information have been successfully saved`
                );
                this.hadSend = true;
                this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
              })
              .catch((error) => {
                this.processCatchApiRequest(error, "Boot failed ...");
              });
          }, this.smoothTimeOut);
        } else {
          return false;
        }
      });
    },
    //#endregion

    //#region No receipts
    noReceipts() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      setTimeout(() => {
        let data = {
          transactionCode: this.transactionCode,

          deviceInformation: JSON.stringify(this.getInformationClient()),
        };
        api
          .baseRequest(SETTINGS_TRANSACTION_API.TRANSACTION_NO_RECEIPTS, data)
          .then(() => {
            this.notificationSuccess(
              "Success ... !",
              `Your information have been successfully saved`
            );
            this.region = null;
          })
          .catch((error) => {
            this.processCatchApiRequest(error, "Boot failed ...");
          });
      }, this.smoothTimeOut);
    },
    //#endregion
  },
};
</script>